import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { formatReduction, getRatioGain, getRatioGainColor } from '../../../../utils/format';

type Props = {
    gainsCheval: number;
    plafond?: number;
    recul?: number;
    averageRed?: number;
};

export const EngagementRow: FC<Props> = ({
    gainsCheval,
    plafond,
    recul,
    averageRed,
}) => {
    const isMobile = useMediaQuery((theme) =>
        theme.breakpoints.down('md')
    );

    const ratio = getRatioGain(gainsCheval / 100, plafond, recul);

    return (
        <Box mt={0.5} display="flex" alignItems="center" flexWrap="wrap" gap={1}>
            {gainsCheval != null && (
                <>
                    {/* Gains */}
                    <Typography
                        variant="caption"
                        fontSize={isMobile ? 12 : 14}
                    >
                        {isMobile ? `${(gainsCheval / 100).toLocaleString('fr-FR')}€` : `Gains : ${(gainsCheval / 100).toLocaleString('fr-FR')}€`}
                    </Typography>

                    {/* Ratio engagement */}
                    {ratio != null && (
                        <>
                            {(plafond && plafond > 0) && <Typography
                                variant="caption"
                                fontSize={isMobile ? 12 : 14}
                            >{"/"}</Typography>}

                            <Typography
                                variant="caption"
                                fontSize={isMobile ? 12 : 14}
                                color={getRatioGainColor(ratio * 100, false)}
                            >
                                {isMobile ? `${Math.round(ratio * 100)}%` : `${Math.round(ratio * 100)}% du plafond`}
                            </Typography>
                        </>
                    )}
                </>
            )}

            {/* Réduction kilométrique */}
            {averageRed != null && averageRed > 0 && (
                <>
                    <Typography
                        variant="caption"
                        fontSize={isMobile ? 12 : 14}
                        color="text.disabled"
                    >
                        •
                    </Typography>
                    <Typography
                        variant="caption"
                        fontWeight={600}
                        fontSize={isMobile ? 12 : 14}
                        color="primary.main"
                    >
                        {formatReduction(averageRed)}
                    </Typography>
                </>
            )}
        </Box>
    );
};
